export default "assets/images/back-arrow-a84cbf25.png";